import { combineReducers } from 'redux';

import { organization } from './organizationReducer';
import { accounts } from './accountReducer';
import { entities } from './entityReducer';
import { scenarios } from './scenarioReducer';
import { business } from './businessReducer';
import { entityBrowser } from './entityBrowserReducer';
import { reporting } from './reportingReducer';
import { periods } from './periodsReducer';
import { exporting } from './exportReducer';
import { exportConfigs } from './exportConfigReducer';
import { currency } from './currencyReducer';
import { allocations } from './allocationReducer';
import { undo } from './undoReducer';
import assemblyReducer from "../slices/assemblySlice";

export default combineReducers({
    organization,
    accounts,
    entities,
    scenarios,
    business,
    entityBrowser,
    reporting,
    periods,
    exporting,
    exportConfigs,
    currency,
    allocations,
    undo,
    assembly: assemblyReducer,
});
